export default "__VITE_ASSET__BuAaP25c__"